import React, { useState } from "react";
import useActions from "../../hooks/service-actions.hook";
import { ToolEffectActions } from "../../common/services/security-stack-view/tool.service";
import { useEntity } from "../../hooks/use-entity.hook";
import UpdateToolModal from "./toolset-selection/browse-by-technology/update-tool-modal/update-tool.modal";
import { FlaggersMethods } from "../../common/store/flaggers/flaggers.methods";
import { Flaggers } from "../../common/store/flaggers/flaggers.enum";
import PracticeConnectModal from "./toolset-selection/browse-by-technology/practice-connect-modal/practice-connect.modal";
import useLoaders from "../../hooks/use-loaders.hook";
import { Loaders } from "../../common/store/loaders/loaders.enum";
import { PracticeConnectModalData, UpdateToolModalData } from "../../common/types/tool.types";
import "./securityStack.scss";

interface ToolsPracticesModalsContainerProps {
  clientId?: number;
  isView?: boolean;
  refreshData?: (kwargs: { clientId?: number }) => void;
}

const ToolsPracticesModalsContainer = ({ clientId, isView = false, refreshData = () => {} }: ToolsPracticesModalsContainerProps) => {
  const { removeToolFromStack, updateTool } = useActions(ToolEffectActions);

  const { setEntityData: setToolModal, entityData: toolModalData } = useEntity<UpdateToolModalData | null>({ entityType: Flaggers.UpdateToolModalFlagger });
  const { setEntityData: setPracticeModal, entityData: practiceModalData } = useEntity<PracticeConnectModalData | null>({ entityType: Flaggers.UpdatePracticeModalFlagger });
  const { isLoading: isRemovingTool } = useLoaders({ loaders: [Loaders.RemoveToolFromStackLoader] });
  
  const [pendingPracticeModal, setPendingPracticeModal] = useState<any>(null);

  const toolModalClientId = clientId || toolModalData?.clientId;
  const practiceModalClientId = clientId || practiceModalData?.clientId;

  const handlePracticeSaveAnother = (practice: any) => {
    setPracticeModal({
      show: true,
      practice,
    }, FlaggersMethods.UpdateFlagger);
    setToolModal(null, FlaggersMethods.UpdateFlagger);
  }

  const handleRefreshData = () => {
    refreshData({ clientId: toolModalClientId || practiceModalClientId });
  }

  const handleToolRemove: any = ({ isCustom }: { isCustom: boolean }) => {
    const toolId = (toolModalData as any)?.tool?.obj_IntegrationId;
    if (toolId) {
      removeToolFromStack({ toolId, isCustom, callback: handleRefreshData });
    }
  }

  const handleToolSave = (toolData: any) => {
    const originalCallback = toolData.callback;
    updateTool({ 
      ...toolData, 
      clientId,
      isToolUpdate: true,
      callback: (response: any) => {
        if (originalCallback) {
          originalCallback();
        }
        if (pendingPracticeModal) {
          const newTool = {
            ToolName: toolData.ToolName,
            ToolIcon: '',
            obj_IntegrationId: response?.mr?.EntityId,
          }
          setPracticeModal({
            show: true,
            practice: pendingPracticeModal,
            newTool: newTool,
            clientId: practiceModalClientId,
          }, FlaggersMethods.UpdateFlagger);
          setPendingPracticeModal(null);
        }
        handleRefreshData();
      }
    });
  }

  const handleOpenUpdateToolModal = (toolName: string) => {
    if (practiceModalData?.practice) {
      setPendingPracticeModal(practiceModalData.practice);
    }
    
    const tool = {
      ToolName: toolName,
      ToolIcon: "",
      obj_IntegrationId: 0,
    };
    setToolModal({
      show: true,
      tool: tool,
      sourcePractice: practiceModalData?.practice,
      clientId: toolModalClientId,
    }, FlaggersMethods.UpdateFlagger);
    setPracticeModal(null, FlaggersMethods.UpdateFlagger);
  }

  return (
    <>
      <UpdateToolModal 
        show={toolModalData?.show || false}
        onHide={() => {
          setToolModal(null, FlaggersMethods.UpdateFlagger);
        }}
        tool={toolModalData?.tool}
        toolInfo={toolModalData?.toolInfo}
        practice={toolModalData?.practice}
        sourcePractice={toolModalData?.sourcePractice}
        showToolInfo={toolModalData?.showToolInfo}
        showCreateLicenses={toolModalData?.showCreateLicenses}
        showRemoveButton={toolModalData?.showRemoveButton}
        technologiesTitle={toolModalData?.technologiesTitle}
        onSave={handleToolSave}
        onRemove={handleToolRemove}
        onSaveAndAddAnother={handlePracticeSaveAnother}
        refreshData={handleRefreshData}
        isRemovingTool={isRemovingTool}
        clientId={toolModalClientId}
        isView={isView}
      />
      <PracticeConnectModal 
        show={practiceModalData?.show || false}
        onHide={() => {
          setPracticeModal(null, FlaggersMethods.UpdateFlagger);
          setPendingPracticeModal(null);
        }}
        refreshData={handleRefreshData}
        practice={practiceModalData?.practice}
        newTool={practiceModalData?.newTool}
        clientId={practiceModalClientId}
        onOpenUpdateToolModal={handleOpenUpdateToolModal}
        isView={isView}
      />
    </>
  );
};

export default ToolsPracticesModalsContainer;
